module.exports = __webpack_public_path__ + "img/icon-time-line.315424a.svg";